
import { Component, ViewChild, TemplateRef, ElementRef, Input, OnInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AppService } from '../app.service';
import { qmsService } from '../qms/qms.service';
import { forkJoin, firstValueFrom } from 'rxjs';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EditorComponent } from '../editor/editor.component';
@Component({
  selector: 'app-followup-due-date',
  templateUrl: './followup-due-date.component.html',
  styleUrls: ['./followup-due-date.component.scss']
})
export class FollowupDueDateComponent implements OnInit, OnChanges {
  refreshbreadcrumb: boolean = true;
  dateCustomClasses: DatepickerDateCustomClasses[];
  isProcessing: boolean = false;
  groupValueDropdown: any = [];
  selectedGroupValue: any = null;
  groupdataList: any = [];
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  departmentCodeDropdown: any = [];
  dropDownForDepartmentCode: any = [];
  selectedDepartmentValue: any = [];
  searchByDepartmentCode: any = null;
  annualRefNo: any;
  followupDueList: any = [];
  showCharts: boolean = false;
  chartOptionsForFollowupDueDate: any;
  followupDueTableDataList: any = [];
  pager: any = {};
  titleName = '';
  pagedItems1: any[];
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  isDropdownDisabled: boolean = true;
  @ViewChild(BreadcrumbComponent) breadcrumbComponent!: BreadcrumbComponent;

  constructor(public dialog: MatDialog, public appService: AppService, public message: messageService, public router: Router, public snackBar: MatSnackBar,
    public elem: ElementRef, public route: ActivatedRoute, public service: messageService, public qmsservice: qmsService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute, public paginationService: PaginationService) {
    const now = new Date();
    this.appService.isProcessingRep = false;
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;
  reportPopupConfig = {
    width: '120%',
    height: '680px',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '10px', left: '125px' },
    maxWidth: '90vw',
  };
  colorList: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#05004E',
    '#839EFF',
    '#00A6A9',
    '#0081A5'
  ];
  colorMethod(val: any, iVal: any) {
    if (val == "Closed" || val == "Completed" || val == "Passed") {
      return "#96E480";
    } else if (val == "Critical" || val == "High") {
      return "#EB5757";
    } else if (val == "Major" || val == "Medium") {
      return "#FF947A";
    } else if (val == "In Progress" || val == "Minor") {
      return "#005C8A";
    } else {
      return this.colorList[iVal];;
    }
  }
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(data: any, column: string, val: any, view: string) {
    console.log("prim", data);
    this.isProcessing = true;
    const formattedColumn = this.formatColumnName(column);
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, formattedColumn);
    this.isProcessing = false;
  }
  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  selectBoxeForGroupValue() {
    this.isProcessing = true;
    this.groupValueDropdown = [];
    for (const group of this.groupdataList) {
      this.groupValueDropdown.push({
        valueExp: group.groupId,
        displayExp: group.groupName
      });
    }
    this.isProcessing = false;
  }
  handleDropDownValidation(fieldId: string, selectedItems: [] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'pdf-select-all');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;
    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }
  }

  selectBoxeForDepartmentCode() {
    for (const department of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown.push({
        valueExp: department.codelistCode,
        displayExp: department.codelistName
      });
    }
  }
  resetFunction() {
    this.searchByDepartmentCode = null;
    this.annualRefNo = "";
    this.showCharts = false;
  }
  genFollowupReport() {

    if (this.selectedGroupValue) {

      const data = {
        groupId: this.selectedGroupValue ?? null,
        module: "FOLLOWUP",
        dateRangeAt: null,
        fromDate: null,
        toDate: null,
        intervals: null,
        stageName: null,
        status: null,
        deptCode: this.searchByDepartmentCode ?? null,
        annualRefNo: this.annualRefNo ?? null
      };

      this.isProcessing = true;

      const promises = [
        this.appService.getAuFollowupDueDateVal(data)
      ].map(observable => firstValueFrom(observable));

      Promise.all(promises)
        .then(([followupDueList]) => {
          this.followupDueList = followupDueList;
          this.createChart();
          this.isProcessing = false;
        })
        .catch(error => {
          console.error('Error in forkJoinObservable:', error);
          this.isProcessing = false;
        });
      return;
    }
    console.log("this.selectedGroupValue=", this.selectedGroupValue);
    const field = document.getElementById('groupNameAlert') as HTMLInputElement;
    if (field) {
      field.style.color = 'red';
    }
  }
  createChart() {
    this.chartOptionsForFollowupDueDate = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF",
            borderColor: "#007BFF",
            borderWidth: 1
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "Followup DueDate",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{duedateindays}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForFollowupDueDAte(),
        click: this.handleFollowupDuedateChartClick.bind(this)

      }]
    };
    this.moveTop();
  }
  moveTop() {
    this.showCharts = true;
    setTimeout(() => {
      window.scrollTo({ top: 220, behavior: 'smooth' });
    }, 1000);
  }
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  handleFollowupDuedateChartClick(e: any): void {
    this.titleName = "Followup Status"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("followup", this.followupDueList[e.dataPointIndex].duedateindays, "");
    this.clickedType = "Followup Due Date";
    this.clickedVal = this.followupDueList[e.dataPointIndex].duedateindays;
    this.clickedStageStatusVal = "";
  }

  getDataPointsForFollowupDueDAte() {
    const dataPoints = this.followupDueList.map((followupDue: { count: any; duedateindays: any; }, index: any) => ({
      y: followupDue.count,
      indexLabel: `${followupDue.duedateindays}:${followupDue.count}`,
      color: this.colorMethod(followupDue.duedateindays, index)
    }));
    return dataPoints;
  }



  clickedType = "";
  clickedVal = "";
  clickedStageStatusVal = "";

  whereValsForExcel: any;
  tableDataList(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log("tableDataList");
    let whereVals;
    whereVals = " WHERE DUEDATEINDAYS='" + valueOfWhere + "'";
    this.whereValsForExcel = whereVals;
    let data;
    data = {
      groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
      module: "FOLLOWUP",
      dateRangeAt: null,
      fromDate: null,
      toDate: null,
      intervals: null,
      stageName: null,
      status: null,
      deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
      annualRefNo: this.annualRefNo ?? null,
      wherVal: whereVals
    }
    this.isProcessing = true;
    forkJoin([
      this.appService.getAuFollowupDueDateTableVal(data)]).subscribe(([followupduetableList]) => {
        this.followupDueTableDataList = followupduetableList;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.followupDueTableDataList.length;
        this.totalPages = Math.ceil(this.followupDueTableDataList.length / this.itemsPerPage);
        this.setPage1(1, 0);
        this.isProcessing = false;
      });
    this.columnList = "Due Date in Days,Group ID,Sub Group Name,Annual Reference Number,Audit Department,Organization ID,AU Number,Follow-up ID,Finding ID,Responses Pending,Assigned To User,Assigned To User Name,Assigned To Department,Assigned To User Details,Due Date,Completed On,Comments,Status,Created On,Created By,Created By User,Updated On,Updated By,Updated By User";
  }
  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
  }
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.followupDueTableDataList.length, page, this.perPage, targetpage);
    if (this.followupDueTableDataList.length > 0) {
      this.pagedItems1 = this.followupDueTableDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  clickedChartVal: any;

  //Excell & PDF
  popupDataTitle: any = {};
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  isSaveReport: boolean = false;

  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  reportName: any;
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      tname = "QMS_AU_FOLLOWUPS_DUEDATE_VW";
      colList = "DUEDATEINDAYS,GROUP_ID,SUB_GROUP_NAME,ANNUAL_REF_NO,AUDIT_DEPARTMENT,ORG_ID,AU_NO,FOLLOWUP_ID,FINDING_ID,RESPONSES_PENDING,ASSIGNED_TO_USER,ASSIGNED_TO_USER_NAME,ASSIGNED_TO_DEPARTMENT,ASSIGNED_TO_USER_DETAILS,DUE_DATE,COMPLETED_ON,COMMENTS,STATUS,CREATED_ON,CREATED_BY,CREATED_BY_USER,UPDATED_ON,UPDATED_BY,UPDATED_BY_USER";
      fieldList = "Due Date in Days,Group ID,Sub Group Name,Annual Reference Number,Audit Department,Organization ID,AU Number,Follow-up ID,Finding ID,Responses Pending,Assigned To User,Assigned To User Name,Assigned To Department,Assigned To User Details,Due Date,Completed On,Comments,Status,Created On,Created By,Created By User,Updated On,Updated By,Updated By User";
      const data = {

        groupId: this.qmsservice.selectedGroup
      }
      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: "",
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: null,
        codelistGroup: null,
        manualEntryDataFields: null,
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: null,
        reModule: "qms",
        logoId: this.selectedReportLogoValue ?? 0,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? `${this.clickedType}_${this.clickedVal}`,
        currentStatus: "NA",
        groupName: this.qmsservice.activity.groupName + "",
      }
      let data2 = {

        groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
        module: this.qmsservice.moduleName,
        dateRangeAt: null,
        fromDate: null,
        toDate: null,
        intervals: null,
        stageName: null,
        status: null,
        wherVal: this.whereValsForExcel
      }
      this.reportObj = { ...data1, ...data, ...data2 };
      debugger;
      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
        .format(new Date(timestamp))
        .replaceAll(',', '')
        .replaceAll(' ', '_');

      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
      const fileName = `${this.clickedType}_${this.clickedVal}_${formattedDate}.${fileType}`;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: this.clickedChartVal, columns: [],
          "informationTab": {
            "Report Name": `${this.clickedType}_${this.clickedVal}` + "Report",
            "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, fileName + ".xlsx");
      } else {
        const pdfData = {
          ...this.reportObj, title: `${this.clickedType}_${this.clickedVal}` + "Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, fileName + ".pdf");

      }
    }
  }
  openReportPopup(item: any) {
    this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();

    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.pdfColumnSelection = false;
    this.isSaveReport = false;
  }
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }
  onDeSelect() {
    this.onSelect();
  }
  onSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }
  onDeSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  //end excell & pdf
  //more activity
  moreActivityReportDetails(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/MoreActivityReportDetailsComponent/', this.qmsservice.moduleName]);
    }
  }
  auditFindingReportDetails(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/AuditReportFindingDetailComponent/', this.qmsservice.moduleName]);
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
    }
  }
  findingDueDate(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
      this.router.navigate(['/dashboard/findingDueDate/', this.qmsservice.moduleName]);
    }
  }
  followupDueDate(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
      this.router.navigate(['/dashboard/followupDueDate/', this.qmsservice.moduleName]);
      if (this.selectedGroupValue) {
        this.genFollowupReport();
      }
    }
  }

  applyFilter1(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems1 = this.followupDueTableDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems1 = this.followupDueTableDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  ngOnChanges() {
    console.log(this.refreshbreadcrumb)
    this.message.breadcrumbData.secondLevel = this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
    this.message.breadcrumbData.thirdLevel = 'Report';
    this.message.breadcrumbData.fourthLevel = this.qmsservice.reportFor;
    if (this.breadcrumbComponent) {
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      this.breadcrumbComponent.thirdLevel = 'Report';
      this.breadcrumbComponent.fourthLevel = this.qmsservice.reportFor;
    }
    this.refreshbreadcrumb = true;
    console.log(this.refreshbreadcrumb)
  }

  groupSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  onGroupValueSelect1st(item: any) {
    console.log("=====", item);
    this.handleDropDownValidation('groupNameAlert', item);
  }
  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.appService.getQmsGroupDetailsByModule(this.selectedGroupValue[0]?.valueExp ?? null, this.qmsservice.moduleName).subscribe((data: any) => {
        this.qmsservice.selectedGroupDetailData = data;
        this.appService.getTypeSettingsByGrpIdGrpDetailId(item.valueExp, data.groupDetailId).subscribe((response: any) => {
        })
      });
      this.handleDropDownValidation('groupNameAlert', this.selectedGroupValue)
    }
  }
  departmentSearchText: string = '';

  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  @ViewChild('pdf') pdf: MatSelect;
  pdfColumnSelection = false;
  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfColumnSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });

    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  onPDFSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.pdfColumnSelection = this.excelPdf.dropDown.length == this.selectedColumns.length;
        this.convertArrayToString(this.selectedColumns);
      })
    }
  }

  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfColumnSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            console.log("this.imageIdList=", this.imageIdList);
            console.log("this.organizationReportImageDetails=", this.organizationReportImageDetails.length);
            for (const organizationReportImageDetail of this.organizationReportImageDetails) {
              console.log(
                "this.organizationReportImageDetails=",
                organizationReportImageDetail.reportImageId,
                this.imageIdList[i]
              );
              if (organizationReportImageDetail.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: organizationReportImageDetail.reportImageId,
                  displayExp: organizationReportImageDetail.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const organizationReportImageDetail of this.organizationReportImageDetails) {
          if (organizationReportImageDetail.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: organizationReportImageDetail.reportImageId,
              displayExp: organizationReportImageDetail.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const reportLogoDropdownVal of this.reportLogoDropdown) {
          if (reportLogoDropdownVal.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = reportLogoDropdownVal.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;
        console.log("data", this.reportFooterDropdown1)
        this.selectBoxForFooter();
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {

      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qmsservice.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.selectedGroupValue = this.qmsservice.SelectedGroupNameAndValue[0].valueExp;
      this.refreshbreadcrumb = false;
      this.ngOnChanges();
      this.onGroupValueSelect1st({ valueExp: this.qmsservice.SelectedGroupNameAndValue[0].valueExp, displayExp: this.qmsservice.SelectedGroupNameAndValue[0].displayExp })
      console.log("data activity", this.qmsservice)
      forkJoin([
        this.appService.getQmsReportUsers(this.qmsservice.moduleName),
        this.appService.getCodeListsByGroup('AUDIT_DEPARTMENT'),
      ]).subscribe(([groupdataList, auditDepartment]) => {
        this.groupdataList = groupdataList;
        this.selectBoxeForGroupValue();
        this.dropDownForDepartmentCode = auditDepartment;
        this.selectBoxeForDepartmentCode();
        if (this.selectedGroupValue) {
          this.genFollowupReport();
        }
      });
    });


    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.selectedGroupValue).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    this.ngOnChangesReportFooter();

  }
}
